import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from './AuthProvider.js';

const CREATE_ORG_PATH = '/app/onboarding/create-org';
const SELECT_ORG_PATH = '/app/select-org';
const WIZARD_PREFIX = '/app/onboarding/wizard';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { loading, user, activeOrgId, activeOrgFiscalConfigComplete, memberships } = useAuth();
  const loc = useLocation();
  if (loading) return null;
  if (!user) return <Navigate to={`/login?return=${encodeURIComponent(loc.pathname)}`} replace />;
  // Onboarding pages are themselves protected (need a session) but must be
  // reachable WITHOUT a membership/active-org — otherwise the redirect loops
  // back to itself and the page renders blank.
  if (
    loc.pathname === CREATE_ORG_PATH ||
    loc.pathname === SELECT_ORG_PATH ||
    loc.pathname.startsWith(WIZARD_PREFIX)
  ) {
    return <>{children}</>;
  }
  if (memberships.length === 0) return <Navigate to={CREATE_ORG_PATH} replace />;
  if (!activeOrgId) return <Navigate to={SELECT_ORG_PATH} replace />;
  // Enforce mandatory wizard: orgs with incomplete fiscal config must finish onboarding
  // before accessing any other protected page.
  if (activeOrgFiscalConfigComplete === false && !loc.pathname.startsWith(WIZARD_PREFIX)) {
    return <Navigate to="/app/onboarding/wizard" replace />;
  }
  return <>{children}</>;
}
